import React, { useEffect, useState } from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { inRange, isEmpty } from "lodash";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import moment from "moment";
import { AmountArray, validationRules, bankType } from "../Utils/constants";
import { useTranslation } from "react-i18next";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import iconBkash from "../assets/images/bkash.webp";
import iconRocket from "../assets/images/rocket.webp";
import iconNagad from "../assets/images/nagad.webp";
import iconEth from "../assets/images/eth.svg";
import iconBtc from "../assets/images/btc.svg";
import iconUpay from "../assets/images/upay.webp";
import iconTrc20 from "../assets/images/trc20.svg";
import selectCheck from "../assets/images/select-check.svg";
import { FaBtc } from "react-icons/fa";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DesktopSidebar from "../components/DesktopSidebar";
import { PromotionalModal } from "../components/PromotionalModal";
import { FaXmark } from "react-icons/fa6";
import { BsArrowRight } from "react-icons/bs";
import taka from "../assets/images/taka.webp";
import ReactPlayer from "react-player";
import DepositWithdrawTabs from "../components/DepositWithdrawTabs";

const Deposit = () => {
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    clearErrors,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const { offerCode } = useParams();
  const [image, setImage] = useState("");
  const navigate = useNavigate();
  const [dataOffer, setDataOffer] = useState([]);
  const [bank, setBank] = useState([]);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );
  const amountDeposit = useContextSelector(
    AuthContext,
    (ctx) => ctx.amountDeposit,
  );
  const getProfileData = useContextSelector(
    AuthContext,
    (ctx) => ctx.getProfileData,
  );
  const downloadBar = useContextSelector(AuthContext, (ctx) => ctx.downloadBar);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const [isLoader, setLoader] = useState(false);
  const [offer, setOffer] = useState("");
  const [modal, setModal] = useState(false);
  const [paymentType, setPaymentType] = useState("offline");

  // useEffect(() => {
  //   if (profileData.defaultPaymentType) {
  //     setPaymentType(profileData.defaultPaymentType);
  //   }
  // }, [profileData.defaultPaymentType]);

  const [selectedMethod, setSelectedMethod] = useState("");


  useEffect(() => {
    if (paymentType === "online") {
      const defaultMethod = bankType.find(
        (m) => m.bank_name.toLowerCase() === "bkash"
      );

      if (defaultMethod) {
        setSelectedMethod(defaultMethod.bank_name);
        setValue("bank", defaultMethod._id); // react-hook-form
      }
    }
  }, [paymentType, setValue]);
  const onSubmit = async (body) => {
    setLoader(true);

    try {
      let imageCheck = "";

      if (image) {
        imageCheck = await uploadImage(image);
      }

      const payload = {
        depositType: paymentType,
        amount: body?.amount,
        offer: offer,
        bank: body?.bank,
        AccountName: body?.accountName,
        BankAccount: body?.bankAccount,
      };

      if (paymentType === "online") {
        payload.transactionType = selectedMethod.toUpperCase();
        payload.payin = true;
      } else {
        payload.transactionType = paymentType;
        payload.TransactionId = body?.transactionId;
        payload.TransactionFile = image ? imageCheck : "";
      }
      //  console.log(payload,"payload"); return false;
      const { status, data } = await apiPost(apiPath.depositAmount, payload);

      if (status !== 200) {
        return toast.error(data?.message || "Something went wrong");
      }

      // Online Payment
      if (
        paymentType === "online" &&
        data?.results?.payment_url
      ) {
        window.location.href = data.results.payment_url;
        return;
      }

      // Offline Payment
      if (data?.results) {
        toast.success(data?.message);
        amounutRefresh();
        getProfileData();
        setImage("");
        reset();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "deposit",
    });
    if (status == 200) {
      if (data?.success) {


        setBank(
          paymentType === "online"
            ? bankType
            : data?.results?.bankList || []
        );
      }
    }
  };

  const getBankDetail = async (body) => {
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };

  const uploadImage = async (obj) => {
    try {
      const form = new FormData();
      form.append("TransactionFile", obj);

      const { status, data } = await apiPost(apiPath.reciptUpload, form);

      if (status === 200) {
        return data?.path;
      } else {
        toast.error(data?.message || "Failed to upload image.");
        return false;
      }
    } catch (error) {
      console.error("Image upload failed:", error);
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred during image upload.",
      );
      return false;
    }
  };
  useEffect(() => {
    if (paymentType) {
      getBank();
    }
  
  }, [paymentType]);

  useEffect(() => {
    if (amountDeposit?.check && amountDeposit?.amount > 0) {
      setValue("amount", amountDeposit?.amount);
    }
  }, [amountDeposit?.check]);

  const { t } = useTranslation();
  const checkIfInRange = (number) => {
    return dataOffer
      ?.find((res) => {
        return res?._id == offer;
      })
      ?.variation.some((item) => {
        const min = parseFloat(item.depositeVaritationMin);
        const max = parseFloat(item.depositeVaritationMax);
        return number >= min && number <= max;
      });
  };
  const [fiexdOffer, setFixedOffer] = useState(0);

  let priceValue = 0;
  const priceCalculate = async (price) => {
    priceValue += price;
    setValue("amount", priceValue);

    const matchedOffer = dataOffer?.find((res) => res?._id == offer);

    if (matchedOffer?.variation?.length) {
      const match = matchedOffer.variation.find((item) => {
        const min = parseFloat(item.depositeVaritationMin);
        const max = parseFloat(item.depositeVaritationMax);
        return priceValue >= min && priceValue <= max;
      });

      if (match) {
        setFixedOffer(match.depositeVaritationPercentage);
      } else {
        setFixedOffer(0);
      }
    }
  };

  useEffect(() => {
    if (offer) {
      priceCalculate(getValues("amount"));
    }
  }, [offer]);

  const resetPrice = async () => {
    setValue("amount", "");
  };

  const [isCopied, setCopied] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [isCopied]);


  const [minDeposit, setMinDeposit] = useState(100);
  const [maxDeposit, setMaxDeposit] = useState(25000);

  useEffect(() => {
    if (!isEmpty(profileData) && profileData?.limitSetting.length > 0) {
      setMinDeposit(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.minDeposit,
      );
      setMaxDeposit(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.maxDeposit,
      );
    }
  }, [
    !isEmpty(profileData) &&
      profileData?.limitSetting.length > 0 &&
      profileData?.limitSetting[0]?.minDeposit,
  ]);

  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional, {
      category: "Deposit",
    });
    if (status == 200) {
      if (data?.success) {
        let result = data?.results?.offerList?.filter((res) => {
          return res?.category == "Deposit";
        });
        let updated = getFilteredOfferList(
          profileData?.userDepositCount,
          result,
        );
        let find = updated?.find((res) => {
          return res?._id == offerCode;
        });
        // if (!isEmpty(find)) {
        //   setLimit({
        //     minDeposit: find?.minimumDeposite,
        //     maxDeposit: find?.maximumDeposite,
        //   });
        // }
        if (updated?.length > 0) {
          setDataOffer(updated);
          let find = updated?.find((res) => {
            return res?.offerOn == "OnDeposit";
          });
          if (!isEmpty(offerCode)) {
            setOffer(offerCode);
          } else {
            if (!isEmpty(find)) {
              setOffer(find?._id);
              // setLimit({
              //   minDeposit: find?.minimumDeposite,
              //   maxDeposit: find?.maximumDeposite,
              // });
            } else {
              setOffer(updated[0]?._id);
              // setLimit({
              //   minDeposit: updated[0]?.minimumDeposite,
              //   maxDeposit: updated[0]?.maximumDeposite,
              // });
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    getData();
    setOffer(offerCode);
  }, [offerCode, profileData]);


  // console.log(paymentType,selectedMethod, "------------>paymentType");
  return (
    <LayoutNew>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        style={{ position: `absolute`, width: `0`, height: `0` }}
      >
        <defs>
          <symbol
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 0 100 100"
            id="checked_0a488f7d"
          >
            <path
              id="checked_0a488f7d_XMLID_4_"
              class="st0"
              d="M0,100h83.8c9,0,16.2-7.3,16.2-16.2V0L0,100z M88.9,60.1l-24,24c-0.7,0.7-1.7,1.1-2.7,1.1  c-1,0-1.9-0.3-2.7-1.1l-12-12c-1.4-1.4-1.4-3.7,0-5.2c1.4-1.4,3.7-1.4,5.2,0l9.5,9.5l21.5-21.5c1.4-1.4,3.7-1.4,5.2,0  C90.3,56.4,90.3,58.7,88.9,60.1z"
            ></path>
          </symbol>
        </defs>
      </svg>{" "}
      <DepositWithdrawTabs
        className={downloadBar ? "banner-bar-height" : ""}
      />
      <div className="main dw-p deposit-box page-content-box w-100 bg-gradual-black">
        <DesktopSidebar />
        <div className="width70">
          <div className="walletInfo-wrapper w-100 common-box dw-box">
            <div className="tol-wal-bal-box">
              <div className="item">
                <span>{t("Total_Wallet_Balance")}</span>
                <br />
                <span className="amt">
                  BDT {Number(userCoins?.balance).toFixed(2) || 0}
                </span>
                <span className="tolWalBal amt">
                  <div className="bal-loader">
                    <div className="spin-yellow spin">
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
              <div className="item walletBalance-outer border-t mt-2 pt-1">
                <span>
                  {t("Main_Wallet")}: BDT{" "}
                  <span className="walletBalance">
                    {Number(userCoins?.balance).toFixed(2) || 0}
                  </span>
                </span>
                <span
                  onClick={() => navigate("/deposit-history")}
                  className="walletBalance-button"
                >
                  Deposit History
                </span>
              </div>
            </div>
          </div>

          <div className="usrTrans-wrapper common-box form-f mb-66">
            <div className="withdraw-form usrTrans-form">
              <Form
                onSubmit={handleSubmit(onSubmit)}
                id="deposit_form"
                className="deposit_form"
              >
                {/* <div className="usrTrans-seperate">
                  <div className="transaction-title">
                    <span>{t("Deposit_Type")}</span>
                    <span className="important-icon">*</span>
                  </div>
                  <div className="m-auto">
                    <select
                      {...register("depositType", {
                        required: {
                          value: true,
                          message: t("Select_Deposit_Type"),
                        },
                      })}
                      id="depositType"
                    >
                      <option value="">{t("Select_Deposit_Type")}</option>
                      <option value="online" security="true">
                        {t("Online_Transfer")}
                      </option>
                    </select>
                  </div>
                  {errors?.depositType?.message && (
                    <div className="transaction-errMsg text-danger depositMsg">
                      {errors?.depositType?.message}
                    </div>
                  )}
                </div> */}


                <div className="member-menu-box member-list select-group checkbox-style ">
                  <div className="title">
                    <h2>
                      <span>Deposit Channel</span>
                    </h2>
                  </div>
                  <ul className="deposite-channel">
                      {/* <li onClick={() => setPaymentType("online")}>
                      <input
                        type="radio"
                        value="online"
                        checked={paymentType === "online"}
                        onChange={() => setPaymentType("online")}
                      />
                      <label>
                        <span>Okay Pay</span>
                      </label>
                    </li> */}
                    <li onClick={() => setPaymentType("offline")}>
                      <input
                        type="radio"
                        value="offline"
                        checked={paymentType === "offline"}
                        onChange={() => setPaymentType("offline")}
                      />
                      <label>
                        <span>Auto Pay</span>
                      </label>
                    </li>
                  


                  </ul>
                </div>

                <div className="member-menu-box member-list select-group checkbox-style ">
                  <div className="title">
                    <h2>
                      <span>Payment Method</span>
                    </h2>
                  </div>
                  <ul className="col3 ">
                    {/* <li>
                      <input type="radio" checked={true} />
                      <label>
                        <div class="bank">
                          <img alt="bkash" src={taka} />
                        </div>
                        <span>Auto</span>
                        <span class="item-icon">
                          <img alt="bkash" src={selectCheck} />
                        </span>
                      </label>
                    </li> */}
                    {bank?.length > 0 &&
                      bank?.map((res) => {
                        return (
                          <li onClick={() => {
                            if (paymentType === "online") {
                              setSelectedMethod(res.bank_name);
                            } else {
                              getBankDetail(res._id);
                              setSelectedMethod(res.bank_name);
                            }
                          }}>
                            <input
                              type="radio"
                              value={res?._id}
                              {...register("bank")}
                              checked={selectedMethod === res.bank_name}
                            />
                            <label>
                              <div className="bank">
                                <img
                                  alt="bkash"
                                  src={
                                    res?.bank_name
                                      .toLowerCase()
                                      .includes("bkash")
                                      ? iconBkash
                                      : res?.bank_name
                                        .toLowerCase()
                                        .includes("nagad")
                                        ? iconNagad
                                        : res?.bank_name
                                          .toLowerCase()
                                          .includes("rocket")
                                          ? iconRocket
                                          : res?.bank_name
                                            .toLowerCase()
                                            .includes("eth")
                                            ? iconEth
                                            : res?.bank_name
                                              .toLowerCase()
                                              .includes("btc")
                                              ? iconBtc
                                              : res?.bank_name
                                                .toLowerCase()
                                                .includes("upay")
                                                ? iconUpay
                                                : iconTrc20
                                  }
                                />
                              </div>
                              <span>{res?.bank_name}</span>
                              <span className="item-icon">
                                <img alt="bkash" src={selectCheck} />
                              </span>
                            </label>
                          </li>
                        );
                      })}
                  </ul>
                </div>

                {paymentType !== "online" && !isEmpty(watch("bankAccount")) && (
                  <>
                    <div className="usrTrans-seperate bankInfoField bankInfo">
                      <div className="transaction-title">
                        <span>{t("Account_Name")}</span>
                        <span className="copyBtn bg-gradient-secondary">
                          <i className="fas fa-copy"></i>
                        </span>
                      </div>
                      <div className="transaction-option m-auto">
                        <input
                          style={{
                            border: `1px solid #e1e1e130`,
                            color: "#fff",
                            backgroundColor: "transparent",
                            WebkitBackgroundClip: "text"
                          }}
                          {...register("accountName")}
                          className="text-input"
                          id="depositAccName"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="usrTrans-seperate bankInfoField bankInfo" style={{ position: 'relative', width: `100%` }}>
                      <div className="transaction-title">
                        <span>{t("Bank_Account")}</span>
                        <span className="copyBtn bg-gradient-secondary">
                          <i className="fas fa-copy"></i>
                        </span>
                      </div>
                      <div className="transaction-option m-auto">
                        <input
                          style={{
                            border: `1px solid #e1e1e130`,
                            color: "#fff",
                            backgroundColor: "transparent",
                            WebkitBackgroundClip: "text"
                          }}
                          {...register("bankAccount")}
                          disabled
                          className="text-input"
                          id="depositAccNo"
                        />
                        <div className="input-group-btn" style={{ position: 'absolute', right: '0', top: '-10', bottom: '0px', filter: `invert(1)` }}>
                          <span className="btn btn-outline-primary" style={{ backgroundColor: 'transparent', border: '0', padding: '8px', paddingTop: '0px', height: '72%' }}>
                            <CopyToClipboard text={getValues("bankAccount")} onCopy={() => setCopied(true)}>
                              <Button className="copy-btn" style={{ fontSize: `13px`, padding: `5px`, backgroundColor: `#005dac`, color: `#fff` }}>{isCopied ? "Copied!" : "Copy"}</Button>
                            </CopyToClipboard>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="member-menu-box member-list select-group checkbox-style ">
                  <div className="title">
                    <h2>
                      <span>{t("Amount")}</span>{" "}
                      <span className="important-icon">*</span>
                      <i>
                        ৳ {minDeposit} - ৳ {maxDeposit}
                      </i>
                    </h2>
                  </div>
                  <div className="usrTrans-seperate deposit-amount">
                    <div className="transaction-option m-auto">
                      <input
                        {...register("amount", {
                          required: {
                            value: true,
                            message: t("Please_enter_amount"),
                          },
                          validate: (value) => {
                            if (value > 0) {
                              if (Number(value) > Number(maxDeposit)) {
                                return (
                                  "Amount should not be greater than " +
                                  maxDeposit
                                );
                              } else if (
                                Number(value) < Number(minDeposit)
                              ) {
                                return (
                                  "Deposit Amount Should be greater than " +
                                  minDeposit
                                );
                              }
                            } else {
                              return t("Amount_0");
                            }
                          },
                        })}
                        type="number"
                        className="text-input"
                        id="depositAmt"
                        placeholder="0.00"
                        onClick={() => resetPrice()}
                      />
                    </div>
                    {errors?.amount?.message && (
                      <div className="transaction-errMsg text-danger depositMsg">
                        {errors?.amount?.message}
                      </div>
                    )}
                  </div>
                  <div className="active">
                    <ul className="col4 amount-withoffer">
                      {AmountArray?.map((item, key) => {
                        return (
                          <li onChange={() => priceCalculate(item?.amount)}>
                            <input type="radio" name="depositAmount" />
                            <label>
                              {/* {fiexdOffer > 0 && (
                                <div class="bonus-tip hasBonus">
                                  + {fiexdOffer}
                                </div>
                              )} */}

                              <svg class="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck">
                                <use xlinkHref="#checked_0a488f7d"></use>
                              </svg>
                              <span> {"+" + item?.amount} </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="input-group money">
                    <label for="amount">৳</label>
                    <div className="input-wrap ">
                      <input
                        type="text"
                        className=" ng-untouched ng-pristine ng-valid"
                        placeholder="0.00"
                        disabled=""
                      />
                      <a className="delete-btn red"></a>
                    </div>
                  </div>
                </div>

                <div className="member-menu-box member-list select-group checkbox-style ">
                  <div className="title">
                    <h2>
                      <span>Promotional Offers</span>{" "}
                    </h2>
                  </div>

                  <div className="usrTrans-seperate deposit-amount">
                    {dataOffer?.map((res, index) => {
                      return (
                        <div
                          key={index + 1}
                          className={`offer-tab`}
                          style={{
                            border: ".2666666667vw solid rgba(153,153,153,.3)",
                            borderRadius: "5px",
                            padding: "4px",
                            color: "white",
                            fontSize: "13px",
                            border: ` 0.266667vw solid rgb(254 183 12)`,
                            marginBottom: `12px`,
                          }}
                          onClick={() => {
                            setOffer(res?._id); // triggers useEffect
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                              width: "100%",
                              paddingLeft: `29px`,
                            }}
                          >
                            <input
                              type="radio"
                              className="promotion-redio"
                              checked={res?._id == offer}
                              onClick={() => {
                                setOffer(res?._id); // triggers useEffect
                              }}
                            />
                            <div className="act-prom-name">
                              <span
                                style={{ fontSize: `16px`, fontWeight: `600` }}
                              >
                                {res?.title}
                              </span>
                              <span
                                style={{
                                  fontSize: `16px`,
                                  fontWeight: `600`,
                                  color: `#f9dc1c`,
                                }}
                              >
                                {">="} {res?.minimumDeposite}
                              </span>
                            </div>
                            <div class="act-prom-remark">
                              <div class="wysiwyg">
                                <p>{res?.description.substring(0, 59)} ....</p>
                              </div>
                            </div>

                            <div class="vc-v2-account-info">
                              <div>
                                Complete below info to participate the promotion
                              </div>
                              {!isEmpty(offer) && res?._id == offer && (
                                <div class="task-item done">
                                  <div class="setting-text">
                                    Bind withdrawal account
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="usrTrans-seperate deposit-amount">
                    <div
                      className={`offer-tab`}
                      style={{
                        border: ".2666666667vw solid rgba(153,153,153,.3)",
                        borderRadius: "5px",
                        padding: "4px",
                        color: "white",
                        fontSize: "13px",
                        border: ` 0.266667vw solid rgb(254 183 12)`,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                          width: "100%",
                          paddingLeft: `29px`,
                        }}
                      >
                        <input
                          type="radio"
                          className="promotion-redio"
                          checked={offer == ""}
                          onClick={() => setOffer("")}
                        />
                        <div className="act-prom-name">
                          <span style={{ fontSize: `16px`, fontWeight: `600` }}>
                            Do not participate in any promotions
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {paymentType !== "online" && (
                  <>
                    <div className="usrTrans-seperate default-type">
                      <div className="transaction-title">
                        <span>{t("Upload_Receipt")}</span>
                      </div>
                      <div className="transaction-option m-auto">
                        <div className="fileupload-box bg-gradient-secondary">
                          <span>{t("Select_an_Image")}</span>
                          <input
                            onChange={(e) => {
                              setImage(e.target.files[0]);
                            }}
                            type="file"
                            className="fileInput"
                            accept="image/png, image/jiffy, image/jpeg, image/jpg"
                            id="depositReceipt"
                            name="depositReceipt"
                          />
                        </div>
                        {image !== "" && (
                          <button
                            onClick={() => setImage("")}
                            className="btn-remove removeReceipt bg-gradient-third"
                          >
                            {t("Remove_Image")}
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="usrTrans-seperate default-type">
                      <div className="transaction-title">
                        <span>{t("Transaction_ID")}</span>
                      </div>
                      <div className="transaction-option m-auto">
                        <input
                          {...register("transactionId", {
                            required: {
                              value: true,
                              message: t("enter_Transaction_ID"),
                            },
                            pattern: {
                              value: validationRules.removeWhitespace,
                              message: "Please enter only number or character",
                            },
                          })}
                          className="text-input"
                          id="depositReferId"
                        />
                      </div>
                      {errors?.transactionId?.message && (
                        <div className="transaction-errMsg text-danger depositMsg">
                          {errors?.transactionId?.message}
                        </div>
                      )}
                    </div></>)}
                {/* <div className="tips-info note">
                  <h5>
                    <i className="tips-icon "></i>
                    <p>
                      Dear all member, to speed up your deposit process, kindly
                      follow these steps : 1.verify the phone number you used
                      for deposit. 2. Input the correct reference number. 3.
                      Process only selected amount. 4. Attach the successful
                      Slip. Reminder: Do not save the phone number displayed on
                      CK75 website on your device to avoid losing money.
                    </p>
                  </h5>
                </div> */}
                <div className="usrTrans-seperate">
                  <div className="transaction-option">
                    <div className="transaction-btn">
                      <button
                        type="submit"
                        disabled={isLoader}
                        className="btn-submit bg-gradient-primary text-capitalize"
                      >
                        {isLoader ? "Loading..." : t("Submit")}
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="deposit-description">
                <div>
                  <span>{t("DEPOSIT_LINE1")}</span>
                </div>
                <div>
                  <span>{t("DEPOSIT_LINE2")}</span>
                </div>
                <div>
                  <span>{t("DEPOSIT_LINE3")}</span>
                </div>
              </div> */}
              </Form>
            </div>
          </div>

          <div className="usrTrans-wrapper"></div>
        </div>
        {/* <ReactPlayer
          style={{ marginBottom: `100px` }}
          muted={false}
          controls={true}
          playsinline={true}
          playing={false}
          width="100%"
          height="auto"
          url={`https://youtu.be/cimFeyVKCRQ?si=IqTlANz6oEWLYmaT`}
          config={{
            file: {
              attributes: {
                preload: "none",
                //forceHLS: true,
              },
              hlsOptions: {
                //autoStartLoad: false,
                startLevel: 3,
              },
            },
          }}
        /> */}
      </div>
      {modal && (
        <PromotionalModal
          offer={offer}
          setOffer={setOffer}
          show={modal}
          onHide={() => setModal(false)}
          dataOffer={dataOffer}
        />
      )}
    </LayoutNew>
  );
};

export default Deposit;
